import { BrowserFileUtils } from '@/platform/utils/BrowserFileUtils'

/**
 * 生成网页端接口签名使用的设备标识。
 * @returns 浏览器环境下返回 UA 与 platform 组合值，非浏览器环境返回 `web`。
 */
function getWebDeviceCode(): string {
  if (typeof navigator === 'undefined') return 'web'
  return `${navigator.userAgent}|${navigator.platform}`.replace(/[^\.\w]/g, '+')
}

export class RequestUtils {
  static key = 'cgapi_lqkj2013'

  /** 网页端无系统版本，用 UA + platform 做 device_code（与 Electron 侧格式约定一致：非字母数字替换为 +） */
  static osVersion = getWebDeviceCode()

  static readonly TOOL_VERSION = '3.5.7.0'

  /**
   * 获取 3.0 工具接口签名使用的工具版本号。
   * @returns 固定工具版本号，当前仅用于旧接口签名参数 `version`。
   */
  static getToolVersion(): string {
    return RequestUtils.TOOL_VERSION
  }

  /**
   * 计算字符串 MD5。
   * @param s 原始字符串。
   * @returns 小写 MD5 字符串。
   */
  static getMd5FromString(s: string): string {
    return BrowserFileUtils.getMd5HashFromString(s)
  }

  /**
   * 按旧工具接口签名规则对 query 字符串进行字典序排序。
   * @param s 原始 query 字符串，不包含问号。
   * @returns 排序后的 query 字符串。
   */
  static getSortString(s: string): string {
    const getInfo = s.split('&')
    getInfo.sort()
    return getInfo.join('&')
  }

  /**
   * 为 CG 旧接口 URL 追加 `sign` 与 `version` 参数。
   * @param url 原始接口路径，可带已有 query 参数。
   * @returns 加签后的接口路径，保留原 query 并追加固定工具版本号。
   */
  static encryptUrl(url: string): string {
    let urlBase: string
    let query: string
    if (url.includes('?')) {
      const urlArr = url.split('?')
      urlBase = urlArr[0]!
      query = urlArr[1]!
    } else {
      urlBase = url
      query = ''
    }
    const toolVersion = RequestUtils.getToolVersion()

    const baseQuery = `version=${toolVersion}`
    const allQuery = query === '' ? baseQuery : `${query}&${baseQuery}`
    const infoStr = RequestUtils.getSortString(allQuery) + RequestUtils.key
    const md5Str = RequestUtils.getMd5FromString(infoStr)
    return `${urlBase}?sign=${md5Str}&${allQuery}`
  }

}


